module.exports = __webpack_public_path__ + "img/closeEye.c22669f4.png";